import _ from 'lodash'
import axios from 'axios'
import store from '@ps/store'
import { deleteComponent, getComponentList, readComponent } from '@ps/api/asset'
import {
  categoryList,
  // commonAudioComponentTypes,
  // commonComponentTypes,
  // commonImageComponentTypes,
  imageSubCategories,
  tabNameList,
} from '@ps/store/workbench/resource-manager/config'
import {
  getCommonComponentList,
  // getCommonComponentSceneList,
  getAssetTag,
  getTagList,
  readCommonComponent,
  getMainTagAssetList,
} from '@ps/api/common/asset'
import {
  componentCategories,
  createComponent,
} from '@ps/bridge/resource/project-store'
import {
  getTransCodeAddPendingId,
  getTranscodeProgress,
  updateProgress,
} from '@pt/utils/assets-transcode'
import { workbenchRoute } from '@ps/router/config'
import { assetsList, getAssetsUsage } from '@pt/api/assets'
import { maxVideoSize, maxAudioSize, maxImageSize } from '@ps/utils/config'
import { addVideoToPlayable } from '@ps/workbench/resource-manager/uploader/video'
import { Message } from 'element-ui'
import { addAudioToPlayable } from '@ps/workbench/resource-manager/uploader/audio'
import { addImageToPlayable } from '@ps/workbench/resource-manager/uploader/image'
import { getFileName, replaceJpegToJpg } from '@com/utils/file'
import { ResponseCode } from '@ps/utils/request'
import i18n from '@ps/lang'
import { cookNodeResourceMap, poolAction } from '@ps/bridge/resource/pool/index'
import { getDescendants } from '@ps/bridge/qc/node/utils'
import game from '@ps/store/workspace/game'
import { checkCanAddResource } from '@ps/store/interactive-video/brain/brain'
import { Event, EventBus } from '@ps/utils/event-bus'
import { isIvPage } from '@ps/router/config'

let source = null
let psResponseTimer = null
const CancelToken = axios.CancelToken

const { pageModes } = workbenchRoute

const getQuery = () => {
  return {
    page: 1,
    page_size: 80,
    keyword: '',
  }
}

export default {
  updateCurrentTab({ state, dispatch }, value) {
    if (state.currentTab && state.currentTab.key === value.key) {
      return
    }
    // 切换 tab 时需要清空不必要的数据
    state.currentTab = value
    state.resourceType = 0
    state.tagId = 0
    state.components = {
      name: '',
      list: [],
    }
    state.hotCommonComponents = []
    state.noMore = false
    state.loading = false
    state.query = getQuery()
    if (state.currentCategory.category === categoryList.playUnit.category) {
      return
    }
    dispatch('getComponents', {
      category: state.currentCategory.category,
    })
  },

  /**
   * 如果有 tagId 与 type，读取指定 type && tag id 的资源；如果有 type 没有 tag id，读取指定 type 的资源；
   * @param data
   * @param category UI 分类名字，根据该 category 决定走哪个策略
   * @param resourceType 资源库类型 id，可选参数，category 与 resourceType 必须是对应的，如 category 为 image 时，那么 resourceType 是图片的子类型，如手指图片库
   * @param tagId resourceType 的 tag id
   * @returns {Promise<void>}
   */
  async getComponents(
    { state, commit, dispatch },
    { data = {}, category, resourceType, tagId, tagClick, groupId },
  ) {
    state.resourceType = resourceType
    state.tagId = tagId
    state.tagClick = tagClick
    psResponseTimer && clearTimeout(psResponseTimer)
    if (state.tagId && !state.resourceType) {
      throw new Error('resourceType is required when tagId is provided')
    }

    // 资源库资源
    if (
      [
        tabNameList.commonAudio,
        tabNameList.commonImage,
        tabNameList.commonEffect,
        tabNameList.commonBgm,
        tabNameList.commonScene,
      ].includes(state.currentTab.key)
    ) {
      // 有 resourceType 代表读取非热门数据
      if (resourceType) {
        return dispatch('getTargetTypeComponents', {
          data,
          category,
          resourceType,
          tagId,
          groupId,
        })
      }
      return dispatch('getHotComponents', { category })
    }
    // 个人资产库资源
    if (
      [
        tabNameList.assetImage,
        tabNameList.assetAudio,
        tabNameList.assetVideo,
        tabNameList.assetEffect,
      ].includes(state.currentTab.key)
    ) {
      return dispatch('getAssetComponents', {
        data: {
          types:
            state.currentTab.key === tabNameList.assetEffect
              ? 'dragonbone,seqframe'
              : null,
          ...data,
        },
        category,
      })
    }
    // 非资源库资源
    return dispatch('getTargetTypeComponents', {
      data,
      category,
      resourceType,
      tagId,
      groupId,
    })
  },

  async getTargetTypeComponents(
    { state, commit, dispatch },
    { data = {}, category, resourceType, tagId, tagClick, groupId },
  ) {
    if (groupId) {
      state.hotCommonComponents = []
      state.hotTagComponents = []
      state.searchTagType = 1
    } else {
      state.searchTagType = 2
    }
    if (tagId) {
      state.searchTagId = tagId
    }
    if (data.page) {
      state.query.page = data.page
    }
    if (data.keyword) {
      state.query.keyword = data.keyword
    }
    // 第一页的时候将 noMore 改为 false，重置列表
    if (state.query.page === 1) {
      state.noMore = false
      state.components = {
        name: '',
        list: [],
      }
    }
    if (state.loading || state.noMore) return

    category = category || state.currentCategory.category
    const pid = Number(data.pid || store.state.workspace.pid)
    const cookReqTag = (tagId) => {
      const filterTag = _.cloneDeep(state.filterSearchTag)
      if (tagId) filterTag.push(tagId)
      return filterTag.join(',')
    }

    const tagSearch = (config, mType) => {
      // 选择标签值
      if (tagClick) {
        return getCommonComponentList(
          { tag_id: cookReqTag(tagId), tool: 1 },
          config,
        )
      }
      // 带tagid搜索逻辑
      if (data.keyword && state.searchTagId) {
        const temp = { name: data.keyword }
        if (state.searchTagType === 1) {
          temp.group_id = state.searchTagId
          if (cookReqTag()) {
            temp.tag_ids = cookReqTag()
          }
        }
        if (state.searchTagType === 2) {
          temp.tag_ids = cookReqTag(state.searchTagId)
        }
        return getCommonComponentList({ ...temp, tool: 1 }, config)
      }
      // 不带tagid搜索
      if (data.keyword && !state.searchTagId) {
        const postdata = { type: mType, name: data.keyword, tool: 1 }
        if (cookReqTag()) {
          postdata.tag_ids = cookReqTag()
        }
        return getCommonComponentList(postdata, config)
      }
      if (state.searchTagId) {
        const temp = { tool: 1 }
        if (state.searchTagType === 1) {
          temp.group_id = state.searchTagId
          if (cookReqTag()) {
            temp.tag_ids = cookReqTag()
          }
        } else {
          temp.tag_ids = cookReqTag(state.searchTagId)
        }
        return getCommonComponentList(temp, config)
      }
      // 是否存在筛选项
      if (cookReqTag()) {
        return getCommonComponentList(
          { tag_ids: cookReqTag(), tool: 1 },
          config,
        )
      }
      return getCommonComponentList({ group_id: tagId, tool: 1 }, config)
    }

    const requestUtils = {
      image: () => {
        const config = {
          cancelToken: source.token,
        }
        if (tabNameList.myImage === state.currentTab.key) {
          return getComponentList(
            {
              ...state.query,
              cat_ids: componentCategories.image,
              pid,
            },
            config,
          )
        }
        return tagSearch(config, 1)
      },
      aImage: () => {
        const config = {
          cancelToken: source.token,
        }

        if (tabNameList.myEffect === state.currentTab.key) {
          return getComponentList(
            {
              ...state.query,
              cat_ids: `${componentCategories.dragonBone},${componentCategories.particle},${componentCategories.xlz}`,
              pid,
            },
            config,
          )
        }
        return tagSearch(config, 2)
      },
      audio: () => {
        const config = {
          cancelToken: source.token,
        }

        if (tabNameList.myAudio === state.currentTab.key) {
          return getComponentList(
            {
              ...state.query,
              cat_ids: componentCategories.audio,
              pid,
            },
            config,
          )
        }
        return tagSearch(config, 3)
      },
      bgm: () => {
        const config = {
          cancelToken: source.token,
        }
        if (tabNameList.myBgm === state.currentTab.key) {
          return getComponentList(
            {
              ...state.query,
              cat_ids: componentCategories.bgm,
              pid,
            },
            config,
          )
        }
        return tagSearch(config, 4)
      },
      video: () => {
        return getComponentList(
          {
            ...state.query,
            cat_ids: componentCategories.video,
            pid,
          },
          {
            cancelToken: source.token,
          },
        )
      },
      effect: () => {
        const config = {
          cancelToken: source.token,
        }

        if (tabNameList.myEffect === state.currentTab.key) {
          return getComponentList(
            {
              ...state.query,
              cat_ids: `${componentCategories.dragonBone},${componentCategories.particle},${componentCategories.xlz}`,
              pid,
            },
            config,
          )
        }
        return tagSearch(config, 5)
      },
      scene: () => {
        const config = {
          cancelToken: source.token,
        }
        return tagSearch(config, 12)
      },
    }

    const response = (res) => {
      if (res.data) {
        state.query.page = state.query.page + 1
        const getArrayList = (res) => {
          let temp = []
          const resList = _.get(res, 'data.result') || []
          resList.forEach((item) => {
            temp = temp.concat(item.list || [])
          })
          return temp
        }
        // 接口返回格式不一致特殊处理
        const resType = _.get(res, 'data.result') ? 1 : 2
        state.components = {
          name: res.data.name,
          list: _.uniqBy(
            [
              ...state.components.list,
              ...(resType === 1
                ? getArrayList(res)
                : _.get(res, 'data.list') || []),
            ],
            'id',
          ),
        }
        if (groupId) {
          state.hotTagComponents = res.data.tags ? res.data.tags : []
        }
        state.noMore = state.components.list.length >= res.data.total
      } else {
        state.noMore = true
      }
    }

    if (_.isFunction(requestUtils[category])) {
      state.loading = true
      if (source) {
        source.cancel('cancel request')
      }
      source = CancelToken.source()
      const res = await requestUtils[category]()
      if (res.code === 0) {
        response(res)
      }
      state.loading = false
    } else {
      throw new Error('没有注册相关的请求函数')
    }
  },

  async getHotComponents({ state, commit }, { category }) {
    state.components = {
      name: '',
      list: [],
    }
    state.hotCommonComponents = []
    state.hotTagComponents = []
    state.searchTagId = ''
    state.searchTagType = ''
    state.resourceType = 0
    state.tagId = 0
    state.query = getQuery()
    state.noMore = false
    if (state.loading) return

    const requestUtils = {
      image: () => {
        return getMainTagAssetList(
          {
            type: 1,
            tool: 1,
          },
          {
            cancelToken: source.token,
          },
        )
      },
      aImage: () => {
        return getMainTagAssetList(
          {
            type: 2,
            tool: 1,
          },
          {
            cancelToken: source.token,
          },
        )
      },
      audio: () => {
        return getMainTagAssetList(
          {
            // type: commonAudioComponentTypes.soundEffect,
            type: 3,
            tool: 1,
          },
          {
            cancelToken: source.token,
          },
        )
      },
      bgm: () => {
        return getMainTagAssetList(
          {
            // type: commonAudioComponentTypes.bgm,
            type: 4,
            tool: 1,
          },
          {
            cancelToken: source.token,
          },
        )
      },
      effect: () => {
        return getMainTagAssetList(
          {
            // type: commonComponentTypes.effect,
            // limit: 6,、
            type: 5,
            tool: 1,
          },
          {
            cancelToken: source.token,
          },
        )
      },
      scene: () => {
        return getMainTagAssetList(
          {
            type: 12,
            tool: 1,
          },
          {
            cancelToken: source.token,
          },
        )
      },
    }

    const response = (res) => {
      if (res.data.list) {
        // 接口更换，接口端返回asssets字段，cook为前端使用的list字段
        res.data.list.forEach((item) => {
          item.list = item.assets
        })
        state.hotCommonComponents = res.data.list
      }
    }

    category = category || state.currentCategory.category
    if (_.isFunction(requestUtils[category])) {
      state.loading = true
      if (source) {
        source.cancel('cancel request')
      }
      source = CancelToken.source()
      const res = await requestUtils[category]()
      if (res.code === 0) {
        response(res)
      }
      state.loading = false
    } else {
      throw new Error('没有注册相关的请求函数')
    }
  },

  // eslint-disable-next-line object-curly-spacing
  getVideoComponents({ state, commit, dispatch, rootState }, { data = {} }) {
    return dispatch('getComponents', { data, category: 'video' })
  },

  async createComponent({ state, rootState }, { data = {}, category }) {
    const { file, files, name } = data
    const pid = Number(data.pid || rootState.workspace.pid)
    state.loading = true

    const res = createComponent({
      name,
      file,
      files,
      pid,
      category,
    })
    state.loading = false
    return res
  },

  /**
   *
   * @param {*} usageCount 是否需要计数，如读取序列帧生成预览动画时不需要计数
   * @param {*} resSource 资源来源 common 公共资源， project 项目资源, asset 资产库资源
   * @param {number} from 资源库来源，新库： 2， 旧库： 1  动画还有旧版粒子是旧库，默认新库
   * @returns
   */
  readComponent(
    { state },
    {
      id,
      base64 = 0,
      usageCount = true,
      resSource = 'project',
      from = 2,
      notCommonResource = false,
    } = {},
  ) {
    const isEditPrefab = store.state.workspace.pageMode === pageModes.editPrefab
    // 优先判定 resSource 参数
    const temp = [
      tabNameList.commonBgm,
      tabNameList.commonEffect,
      tabNameList.commonAudio,
      tabNameList.commonScene,
      tabNameList.commonImage,
      tabNameList.commonScene,
    ].includes(state.currentTab.key)
    const isCommonSource = resSource === 'common' ? true : temp
    const workspaceState = store.state.workspace
    if (isCommonSource && !notCommonResource) {
      const params = {
        id: Number(id),
        base64,
        from, // 默认都沿用新资源库
      }
      // 如果是编辑预设页面，调用公共资源库接口时不传 pid，这样后端就不计使用次数
      // usageCount 是否需要计数，如读取序列帧生成预览动画时不需要计数
      if (!isEditPrefab && usageCount) params.pid = workspaceState.pid
      // 动画不需要使用新的资源库
      // 编辑非新资源库的粒子时，不需要用新资源库
      if (from === 1) {
        delete params.from
      }
      return readCommonComponent(params)
    }
    const params = {
      id: Number(id),
      base64,
    }
    if (resSource === 'asset') {
      params.from = 3
      params.id = String(id)
      params.pid = workspaceState.pid
    }
    return readComponent(params)
  },

  deleteComponent({ state, rootState }, { id }) {
    return deleteComponent({
      id: Number(id),
    })
  },

  async getTagList({ state }, { useCache = true } = {}) {
    if (useCache && !_.isEmpty(state.tagList)) return state.tagList
    const res = await getTagList()
    if (res.code === 0) {
      const list = _.get(res, 'data.tags') || []
      state.tagList = list
      return list
    }
    return []
  },

  async getAssistTag({ state }, { type }) {
    if (state.assistTag[type]) {
      return state.assistTag[type]
    }
    const res = await getAssetTag({
      type,
      tool: 1,
    })
    if (res.code === 0) {
      const list = _.get(res, 'data.list') || []
      state.assistTag = {
        ...state.assistTag,
        [type]: list,
      }
      return list
    }
    state.assistTag = {
      ...state.assistTag,
      [type]: [],
    }
    return []
  },

  openBgmResourceDialog(
    { state, commit, dispatch },
    { position = 'left' } = {},
  ) {
    const category = categoryList.bgm.category
    commit('openDialog', {
      category,
      action: 'add',
    })
    position === 'left'
      ? commit('moveDialogToLeft')
      : commit('moveDialogToRight')
    dispatch('getComponents', {
      category,
    })
  },

  openBgResourceDialog(
    { state, commit, dispatch },
    { position = 'left' } = {},
  ) {
    const category = categoryList.image.category
    commit('openDialog', {
      category,
      action: 'update',
      subCategory: imageSubCategories.bg,
    })
    position === 'left'
      ? commit('moveDialogToLeft')
      : commit('moveDialogToRight')
    dispatch('getComponents', {
      category,
    })
  },

  async getAssetComponents({ state, commit }, { data = {}, category }) {
    const categoryMap = {
      image: 'png,jpg,jpeg', // playsmart 只支持 png , jpg 格式的图片
      audio: 'mp3', // playsmart 只支持 mp3 格式的音频
      video: 'mp4', // playsmart 只支持 mp4 格式的视频
      bgm: 'mp3', // playsmart 只支持 mp3 格式的音频
      aImage: 'zip', //  playsmart 只支持龙骨和序列帧的zip
    }
    // 体积限制
    const maxSizeMap = {
      image: maxImageSize * 1024 * 1024, // 1M
      audio: maxAudioSize * 1024 * 1024, // 1M
      video: maxVideoSize * 1024 * 1024, // 3M
      bgm: maxAudioSize * 1024 * 1024, // 1M
    }
    // 默认按照资产更新顺序由近及远排序展示50条
    const commonParams = {
      page_size: 50,
      order: '-updated_time',
      ...data,
    }
    const requestUtils = () => {
      const config = {
        cancelToken: source.token,
      }
      return assetsList(
        {
          ...commonParams,
          formats: categoryMap[category],
          size_max: maxSizeMap[category],
        },
        config,
      )
    }

    const response = (res) => {
      if (res.data) {
        state.components = {
          name: `asset-${category}`,
          list: _.get(res, 'data.list') || [],
        }
        state.noMore = true
        // 获取正在转码的id
        const { transCodeId } = getTransCodeAddPendingId(state.components.list)
        // 转码进度查询
        if (transCodeId.length) {
          getPsAssetProgress(transCodeId)
        }
      }
    }

    state.loading = true
    if (source) {
      source.cancel('cancel request')
    }
    source = CancelToken.source()
    const res = await requestUtils()
    console.log('getAssetComponents', res)
    if (res.data.code === 0) {
      response(res.data)
    }
    state.loading = false

    // 资源转码
    async function getPsAssetProgress(transCodeId) {
      const { data, update } = await getTranscodeProgress(transCodeId)
      // 直接更新列表
      if (update) {
        const res = await requestUtils()
        if (res.data.code === 0) {
          response(res.data)
        }
        return
      }

      state.components.list = updateProgress(state.components.list, data)

      psResponseTimer = setTimeout(() => {
        getPsAssetProgress(transCodeId)
      }, 3000)
    }
  },

  async addAssetToProject({ rootState, state, commit }, data) {
    commit('updateAssetsDialog', {
      loading: true,
    })
    if (
      !checkCanAddResource(
        rootState.workspace.game.sceneManager.currentSceneNode.uuid,
        data.creative_type,
      )
    ) {
      return
    }
    const currentCategory = data.creative_type
    // 添加视频到项目
    if (currentCategory === 'video') {
      try {
        await addVideoToPlayable({
          isProjectOnly: isIvPage(),
          isAdd: state.action === 'add',
          isAssetMode: true,
          data: {
            ...data,
            icon_url: data.cover_url,
            file_url: data.full_url,
            thumb_url: data.cover_url,
          },
        })
      } catch (error) {
        commit('updateAssetsDialog', {
          loading: false,
        })
        if (Number(error.name) === ResponseCode.AssetNotExists) {
          Message.error(
            i18n.t(
              'workbench.resourceManagers.addResourceToPlayable.editError[2]',
            ),
          )
        } else {
          Message.error(error.message)
        }
        console.log(error)
      }
    } else if (currentCategory === 'audio' || currentCategory === 'bgm') {
      // 添加音频到项目
      try {
        await addAudioToPlayable({
          isAdd: state.action === 'add',
          category: state.currentCategory.category,
          fileUrl: data.full_url,
          fileId: data.id,
          fileName: data.name,
          from: 3,
        })
      } catch (error) {
        commit('updateAssetsDialog', {
          loading: false,
        })
        if (Number(error.name) === ResponseCode.AssetNotExists) {
          Message.error(
            i18n.t(
              'workbench.resourceManagers.addResourceToPlayable.editError[2]',
            ),
          )
        } else {
          Message.error(error.message)
        }
        console.log(error)
      }
    } else if (currentCategory === 'image') {
      // 添加图片到项目
      try {
        await addImageToPlayable({
          isAdd: state.action === 'add',
          isBg:
            state.currentCategory.subCategory === imageSubCategories.bg ||
            rootState.workspace.resourceManager.subCategory ===
              imageSubCategories.bg,
          activeNode: store.state.workspace.game.activeNode,
          fileUrl: data.full_url,
          fileId: data.id,
          isAssetMode: true,
          fileOriginName: replaceJpegToJpg(getFileName(data.full_url)),
        })
      } catch (error) {
        commit('updateAssetsDialog', {
          loading: false,
        })
        Message.error(error.message)
        console.log(error)
      }
    }
    EventBus.$emit(Event.RESOURCE_POOL_REFRESH)
    commit('updateAssetsDialog', {
      visible: false,
      loading: false,
    })
  },

  async replaceAssetToProject({ state, commit }, data) {
    commit('updateAssetsDialog', {
      loading: true,
    })
    try {
      await poolAction.updatePoolResourceByResource({
        resource: {
          ...data,
          icon_url: data.cover_url,
          file_url: data.full_url,
          thumb_url: data.cover_url,
        },
        isFromAssetResourceLibrary: true,
        poolItem: state.replaceResourcePoolItem,
      })
    } finally {
      commit('closeLibDialog', {
        loading: true,
      })
    }
    EventBus.$emit(Event.RESOURCE_POOL_REFRESH)
    commit('updateAssetsDialog', {
      visible: false,
      loading: false,
    })
  },

  async getAssetsUsage({ commit }) {
    try {
      const res = await getAssetsUsage()
      if (!res.data.code) {
        commit('setUsage', res.data.data)
      }
    } catch (e) {
      console.warn(e)
    }
  },

  async initResourcePool({ commit, state }) {
    commit(
      'updateResourcePool',
      cookNodeResourceMap(getDescendants(game.state.UIRoot)),
    )
  },
}
